import { render, staticRenderFns } from "./SerialAssigned.vue?vue&type=template&id=03fcd6d0&"
import script from "./SerialAssigned.vue?vue&type=script&lang=js&"
export * from "./SerialAssigned.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports